import {
  Col,
  Input,
  Label,
  Row,
  InputGroup,
  InputGroupText,
  FormGroup,
} from "reactstrap";
import { FaDatabase, FaLink, FaKey, FaTools, FaBug } from "react-icons/fa";

export const PortalForm = ({ formData, errors, handleChange }) => {
  return (
    <>
      <Row className="mb-3">
        <Col md={6}>
          <Label>Nome do Repositório*</Label>
          <InputGroup>
            <InputGroupText>
              <FaDatabase />
            </InputGroupText>
            <Input
              name="newRepository"
              value={formData.newRepository}
              onChange={handleChange}
              invalid={!!errors.newRepository}
              placeholder="Ex: portal-inteegra"
            />
          </InputGroup>
        </Col>
        <Col md={6}>
          <Label>Subdomínio*</Label>
          <InputGroup>
            <InputGroupText>
              <FaLink />
            </InputGroupText>
            <Input
              name="subDomain"
              value={formData.subDomain}
              onChange={handleChange}
              invalid={!!errors.subDomain}
              placeholder="Ex: portalinteegra"
            />
          </InputGroup>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <Label>Contract ID Dev*</Label>
          <InputGroup>
            <InputGroupText>
              <FaKey />
            </InputGroupText>
            <Input
              name="plusContractIdDev"
              value={formData.plusContractIdDev}
              onChange={handleChange}
              invalid={!!errors.plusContractIdDev}
            />
          </InputGroup>
        </Col>
        <Col md={6}>
          <Label>Contract ID Prod*</Label>
          <InputGroup>
            <InputGroupText>
              <FaTools />
            </InputGroupText>
            <Input
              name="plusContractIdProd"
              value={formData.plusContractIdProd}
              onChange={handleChange}
              invalid={!!errors.plusContractIdProd}
            />
          </InputGroup>
        </Col>
      </Row>

      <FormGroup className="mt-3">
        <Label>Sentry DSN*</Label>
        <InputGroup>
          <InputGroupText>
            <FaBug />
          </InputGroupText>
          <Input
            name="sentryDsn"
            value={formData.sentryDsn}
            onChange={handleChange}
            invalid={!!errors.sentryDsn}
          />
        </InputGroup>
      </FormGroup>
    </>
  );
};
